/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RevokeStripeAuthorizationTokenResponse } from '../models/RevokeStripeAuthorizationTokenResponse';
import type { StripeCSRFTokenRequest } from '../models/StripeCSRFTokenRequest';
import type { StripeOAuthRequest } from '../models/StripeOAuthRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class StripeService {

    /**
     * Revokes the Stripe access token on behalf of an user.
     * @param organizationId The ID of the organization to scope the integrations for.
     * @returns RevokeStripeAuthorizationTokenResponse OK
     * @throws ApiError
     */
    public static revokeStripeAuthorizationToken(
        organizationId: string,
    ): CancelablePromise<RevokeStripeAuthorizationTokenResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/integrations/organizations/{organizationId}/stripe/revokeAuthToken',
            path: {
                'organizationId': organizationId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static storeStripeCsrfToken(
        requestBody?: StripeCSRFTokenRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/integrations/stripe/storeStripeCSRFToken',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static authorizeStripe(
        requestBody?: StripeOAuthRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/integrations/stripe/getAccessToken',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }

}
